import * as React from "react";
import {
    DisplayFeatureType,
    CommonAssociationFeature, DisplayFeature, UserSession,
} from "../../../contract-features-3/domain";
import {Button} from 'react-bootstrap';
import FeatureList from "./FeatureList";
import {AssociatedFeature} from "../../domain/AssociatedFeature";
import {AssociationJson} from "../../domain/AssociationJson";
import {
    DisAssociateTargets,
    SelectTargetFeatureType,
    ToggleSelectedAssociationTarget
} from "../../../../actions/actions";
import {FeatureTypeSummary} from "../../../../../integration/representation/feature-type";
import {FeatureTypeAttributes} from "../../state/AssociationsState";

interface ContractChildAssociationTabProps {
    selectedAssociationTargetType: FeatureTypeAttributes;
    selectedTargetFeatures: CommonAssociationFeature[];
    selectedAssociation: AssociatedFeature;
    selectedSourceFeature: DisplayFeature;

    associationTargetTypes: DisplayFeatureType[];
    targetFeatures: CommonAssociationFeature[];
    featureTypes: FeatureTypeSummary[];
    associationsFlat: AssociationJson[];

    user: UserSession;

    onSelectTargetFeatureType: SelectTargetFeatureType;
    onSelectTargetFeature: ToggleSelectedAssociationTarget;
    onAssociateTargets: Function;
    onDisassociateTargets: DisAssociateTargets;
}

interface ContractChildAssociationTabState {
    filterAssociatedTargets: boolean
}


export default class ContractChildAssociationTab extends React.Component<ContractChildAssociationTabProps, ContractChildAssociationTabState> {

    constructor(props: ContractChildAssociationTabProps) {
        super(props);
        this.state = {
            filterAssociatedTargets: false
        }
    }

    handleSelect(value: string) {
        const parsedValue = parseInt(value);
        const targetFeature = this.props.associationTargetTypes.filter(type => {
            return type.typeId === parsedValue;
        })[0];
        this.props.onSelectTargetFeatureType(targetFeature);
    }

    handleHideAssociatedClick() {
        this.setState({filterAssociatedTargets: !this.state.filterAssociatedTargets})
    }

    featureToggleEnabled(toggle: string): boolean {
        const {user} = this.props;
        return user?.featureToggles?.some(enabledToggle => enabledToggle === toggle) ?? false;
    }
    render() {
        const selectValue = this.props.selectedAssociationTargetType ? this.props.selectedAssociationTargetType.typeId : "";
        const anyTargetsSelected = !!this.props.selectedAssociationTargetType && this.props.selectedTargetFeatures.length > 0;
        const parentIsExporting = !!this.props.selectedSourceFeature && !!this.props.selectedSourceFeature.isExporting;
        const childIsExporting = !!this.props.selectedTargetFeatures &&  this.props.selectedTargetFeatures.some(feature => !!feature.isExporting);
        const {selectedAssociationTargetType, selectedAssociation} = this.props;
        const disableDescriptiveName = this.featureToggleEnabled("DisableDescriptiveFeatureNameInAssociationAndLocationTabs");
        let targetFeatures = this.props.targetFeatures;

        // filter out already associated targets if option is checked
        const filterAssociated = this.state.filterAssociatedTargets;
        if (filterAssociated) targetFeatures = targetFeatures
            // filtrerer bort features som ikke er av operasjon oprett.
            .filter(feature => {return !(feature as any).operation || (feature as any).operation === "CREATE" })
            // Filter features that is not the daughter of something
            .filter(feature => {
                return !this.props.associationsFlat.find(a => a.childFeatureId === feature.id);
        });
                                                                                                                                           3
        const scope = selectedAssociation && selectedAssociation.origin === "NVDB" ? "NVDB_ASSOCIATION_TO_PROJECT_CHILD" : "PROJECT_TO_PROJECT";

        let helpText = "";
        if (parentIsExporting) {
            helpText = "Morobjekt er under eksport til NVDB";
        } else if (childIsExporting) {
            helpText = "Datterobjekt er under eksport til NVDB";
        }

        const view = (
            <div className="associations-creator-content">
                <h2>Koble til døtre i kontrakten</h2>

                <select onChange={(e) => this.handleSelect(e.target.value)} value={selectValue}>
                    {
                        this.props.associationTargetTypes
                            .map(featureType => {
                                return (
                                    <option value={featureType.typeId}
                                            key={featureType.typeId}>{featureType.name}</option>
                                )
                            }, this)
                    }

                </select>

                <div className="associationButtons">
                    <Button type="button" title="Koble sammen valgte objekter" className="associate-button" disabled={!anyTargetsSelected || parentIsExporting || childIsExporting}
                            onClick={() => this.props.onAssociateTargets(scope)}>Koble sammen</Button>
                    <Button type="button" title="Koble fra valgte objekter" className="disassociate-button" disabled={!anyTargetsSelected || parentIsExporting || childIsExporting}
                            onClick={() => this.props.onDisassociateTargets()}>Koble fra</Button>

                    <span className="association-create-error-message">
                        {helpText}
                    </span>


                    <label className="float-right">Skjul koblede<input type="checkbox"
                                                                       onClick={() => this.handleHideAssociatedClick()}
                                                                       checked={filterAssociated}></input></label>

                </div>

                <FeatureList featureType={selectedAssociationTargetType} associationsFlat={this.props.associationsFlat}
                             selectedAssociation={this.props.selectedAssociation}
                             features={targetFeatures}
                             selectedFeatures={this.props.selectedTargetFeatures}
                             onFeatureClick={this.props.onSelectTargetFeature}
                             tabType={"PROJECT_TO_PROJECT"}
                             disableDescriptiveName={disableDescriptiveName}/>
            </div>
        );

        const noSourceTargetView = (
            <div className="associations-creator-content">
                <h2>Koble til døtre i kontrakten</h2>
                <div className="infobox">
                    <p>Velg en morkandidat i venstremenyen</p>
                </div>
            </div>
        );

        const noPotentialTargetTypeView = (
            <div className="associations-creator-content">
                <h2>Koble til døtre i kontrakten</h2>
                <div className="infobox">
                    <p>Ingen aktuelle dattertyper i kontrakten</p>
                </div>
            </div>
        );

        if (!this.props.selectedAssociation) {
            return noSourceTargetView;
        } else if (this.props.associationTargetTypes.length == 0) {
            return noPotentialTargetTypeView;
        }
        return view;
    }

}
